<template>
  <div id="unionCardRecByMonth">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title_item}}</el-breadcrumb-item>
          <el-breadcrumb-item>月租停车明细报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月卡分组::">
          <el-select v-model="selfGroupID"
                     multiple
                     collapse-tags
                     style="width:300px"
                     placeholder="请选择分组"
                     clearable
                     filterable>
            <el-option v-for="item in choiceGroups"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份::">
          <el-date-picker v-model="fYear"
                          type="year"
                          placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="车牌::">
          <el-input placeholder="请输入车牌"
                    v-model="fPlateCode"
                    class="input-with-select">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     :loading="loading"
                     @click="cardQuery">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="cardList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                show-summary
                :summary-method="getSummaries"
                stripe
                ref="singleTable">
        <el-table-column type="index"
                         width="50"
                         label="序号"
                         :index="indexMethod">
        </el-table-column>
        <el-table-column prop="fGroupName"
                         label="类别">
        </el-table-column>
        <el-table-column prop="fStopPlace"
                         width="80"
                         label="停放位置">
        </el-table-column>
        <el-table-column prop="fBatStartTimeTitle"
                         label="登记日期">
        </el-table-column>
        <el-table-column prop="fPlateList"
                         width="150"
                         label="车牌号码">
        </el-table-column>
        <el-table-column prop="fRoomNo"
                         label="房号">
        </el-table-column>
        <el-table-column prop="fCustName"
                         label="客户名称">
        </el-table-column>
        <el-table-column prop="fMonth01"
                         align="right"
                         width="100"
                         :label=fYearMonth1>
        </el-table-column>
        <el-table-column prop="fMonth02"
                         align="right"
                         width="100"
                         :label=fYearMonth2>
        </el-table-column>
        <el-table-column prop="fMonth03"
                         align="right"
                         width="100"
                         :label=fYearMonth3>
        </el-table-column>
        <el-table-column prop="fMonth04"
                         align="right"
                         width="100"
                         :label=fYearMonth4>
        </el-table-column>
        <el-table-column prop="fMonth05"
                         align="right"
                         width="100"
                         :label=fYearMonth5>
        </el-table-column>
        <el-table-column prop="fMonth06"
                         align="right"
                         width="100"
                         :label=fYearMonth6>
        </el-table-column>
        <el-table-column prop="fMonth07"
                         align="right"
                         width="100"
                         :label=fYearMonth7>
        </el-table-column>
        <el-table-column prop="fMonth08"
                         align="right"
                         width="100"
                         :label=fYearMonth8>
        </el-table-column>
        <el-table-column prop="fMonth09"
                         align="right"
                         width="100"
                         :label=fYearMonth9>
        </el-table-column>
        <el-table-column prop="fMonth10"
                         align="right"
                         width="100"
                         :label=fYearMonth10>
        </el-table-column>
        <el-table-column prop="fMonth11"
                         align="right"
                         width="100"
                         :label=fYearMonth11>
        </el-table-column>
        <el-table-column prop="fMonth12"
                         align="right"
                         width="100"
                         :label=fYearMonth12>
        </el-table-column>
        <el-table-column prop="rowSum"
                         align="right"
                         width="100"
                         label="合计">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { unionAPI as union } from '../../../api/unionReport'
import { mapActions } from 'vuex'
import * as user from '../../../api/user'
export default {
  name: 'cardRecByMonth.vue',
  data () {
    return {
      title_item: '香港广场定制报表',
      is_export: false,
      cardList: [],
      choiceCusts: [],
      choiceGroups: [],
      selCustID: '',
      selfGroupID: '',
      loading: false,
      export_loading: false,
      tableHeight: 0,
      pageSize: 20,
      pageNo: 1,
      total: 0,
      fYear: 0,
      fYearMonth1: '',
      fYearMonth2: '',
      fYearMonth3: '',
      fYearMonth4: '',
      fYearMonth5: '',
      fYearMonth6: '',
      fYearMonth7: '',
      fYearMonth8: '',
      fYearMonth9: '',
      fYearMonth10: '',
      fYearMonth11: '',
      fYearMonth12: '',
      fPlateCode: '',
      moneyTotal: {},
      export_msg: '导出'
    }
  },
  watch: {
    fYear (val, oldVal) {
      this.fYearMonth1 = val.getFullYear() + '年1月'
      this.fYearMonth2 = val.getFullYear() + '年2月'
      this.fYearMonth3 = val.getFullYear() + '年3月'
      this.fYearMonth4 = val.getFullYear() + '年4月'
      this.fYearMonth5 = val.getFullYear() + '年5月'
      this.fYearMonth6 = val.getFullYear() + '年6月'
      this.fYearMonth7 = val.getFullYear() + '年7月'
      this.fYearMonth8 = val.getFullYear() + '年8月'
      this.fYearMonth9 = val.getFullYear() + '年9月'
      this.fYearMonth10 = val.getFullYear() + '年10月'
      this.fYearMonth11 = val.getFullYear() + '年11月'
      this.fYearMonth12 = val.getFullYear() + '年12月'
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getCardGroupByCustId'
    ]),
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 255
      obj.tableHeight = clientHeight
    },
    changeCust (fCustID) {
      this.selfGroupID = ''
      this.choiceGroups = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
    },
    cardQuery () {
      this.initData()
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    initData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.cardList = []
      this.loading = true
      var queryParam = {
        fCustID: this.selCustID,
        fYear: this.fYear.getFullYear(),
        fGroupID: JSON.stringify(this.selfGroupID),
        fPlateCode: this.fPlateCode,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }
      union.getRecMoneyListByMonthAsync(queryParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.total = data.Data.total
              this.cardList = data.Data.rows
              this.moneyTotal = data.Data.moneyTotaldic
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      var queryParam = {
        fCustID: this.selCustID,
        fYear: this.fYear.getFullYear(),
        fGroupID: JSON.stringify(this.selfGroupID),
        fPlateCode: this.fPlateCode,
        pageSize: this.pageSize,
        pageNo: this.pageNo
      }
      union.exportCardRecMoneyData(queryParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_月租车明细报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      var index = 0
      for (let key in this.moneyTotal) {
        sums[index] = this.moneyTotal[key]
        index++
      }
      return sums
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    }
  },
  created () {
    var tmpPerTypeId = 881000
    if (this.$route.query.type === '1') {
      this.title_item = '闸北广场定制报表'
      tmpPerTypeId = 1191000
    }
    user.getCurrentUserPers({ perTypeId: tmpPerTypeId }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    this.fYear = new Date()
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
    this.$nextTick(() => {
      this.$refs['singleTable'].doLayout()
    })
  }
}
</script>

<style>
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/unionReport/cardRecByMonth.vue